module.exports = __webpack_public_path__ + "static/media/jumbo1.5df70e19.png";